<template>
	<div>
		<mbBanner title="新闻资讯" />
		<div class="content-nav">
		  <div
			v-for="(type,index) in newstypeList"
		    class="content-nav-btn"
		    :class="{'content-nav-active':type.id == newstype}"
		    @click="newstypeChange(type)"
		  >
		    <span>{{type.name}}</span>
		  </div>
		</div>
		<div class="news">
			<el-row class="news-box" @click.native="goDetails(news)" v-for="(news,i) in newsList" :key="i">
				<el-col >
					<el-image style="width:100%;" :src="news.cover"></el-image>
				</el-col>
				<el-col>
					<p class="news-name">{{news.title}}</p>
					<p class="news-time">{{news.createTime}}</p>
				</el-col>
			</el-row>
			<div v-if="moreShow" class="news-more" @click="getMore">{{ moreText }}</div>
		</div>
	</div>
</template>

<script>
import mbBanner from "./mb_banner.vue";
export default {
	components: {
		mbBanner
	},
	data() {
		return {
			newsList: [],
			pageInfo: {
				curPage: 1,
				pageSize: 5,
				total: 0
			},
			newstype: '',
			moreText: '查看更多资讯>>',
			moreShow: true,
			newstypeList: []
		}
	},
	methods:{
		goDetails(news){
			this.$router.push({ name: 'mb_newsdetails', params: { id: news.id }})
		},
		getMore(){
			this.pageInfo.pageSize += 5
			this.getListByPage()
		},
		newstypeChange(type){
			this.newstype = type.id
			this.pageInfo.pageSize = 5
			this.getListByPage()
		},
		async initPage(){
			await this.getAllList()
			await this.getListByPage()
		},
		async getAllList(){
			// await this.$http.post('/oa/newcms/category/getChildById',{parentId:"a1fbc39c-1969-4e0d-bca1-4304d3b0e52e"})
			// .then(response => {
			// 	this.newstypeList = response.data.result
			// 	this.newstype = this.newstypeList[0].id
			// 	// console.log(response)
			// })
			// .catch(error=> {

			// })
			const {data : { result }} = await this.$http({
				method: 'post',
				url: this.$baseURL + '/base/dict/getDataList',
				data: {
					dictCode: 'articleType'
				}
			})
			const newstypeList = result[0].children
			this.newstypeList = newstypeList.map(item => {
				return {
					id: item.id,
					name: item.dictName
				}
			})
			!this.newstype ? this.newstype = this.newstypeList[0].id : ''
		},
		async getListByPage(){
			var curPage = this.pageInfo.curPage
			var pageSize = this.pageInfo.pageSize
			var category = this.newstype
			// console.log(this.$qs.stringify({curPage,pageSize,category}))
			// this.$http.post('/oa/newcms/article/getListByPage',{curPage,pageSize,category})
			// .then(response => {
			// 	this.newsList = response.data.result.data
			// 	this.pageInfo.total = Number(response.data.result.total)
			// 	if(this.pageInfo.total < this.pageInfo.pageSize){
			// 		this.moreShow = false
			// 	}else{
			// 		this.moreShow = true
			// 	}
			// 	// console.log(response)
			// 	// console.log(this.newsList)
			// })
			// .catch(error=> {

			// })
			const {data : { result }} = await this.$http({
				method: 'post',
				url: this.$baseURL + '/oa/newcmsArticle/getDataListByPage',
				data: {
					curPage,
					pageSize,
					category
				}
			})
			this.pageInfo.total = Number(result.total)
			this.newsList = result.records.map(item => {
				return {
					id: item.id,
					cover: item.cover,
					title: item.title,
					createTime: item.createTime
				}
			})
			if(this.pageInfo.total < this.pageInfo.pageSize){
				this.moreShow = false
			}else{
				this.moreShow = true
			}
		},
	},
	mounted() {
		this.initPage()
	}
}
</script>

<style lang="scss" scoped>
	.content-nav {
	  width: 320px;
	  height: 44px;
	  margin: 0 auto;
	  display: flex;
	  align-items: center;
	  position: relative;
	  bottom: 20px;
	  border: 1px solid #bd282b;
	  font-size: 14px;

	  &-btn {
		cursor: pointer;
		width: 50%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #e4e4e4;
		transition: all 0.2s;
	  }

	  .content-nav-active {
		background-color: #bd282b;
		color: #fff;
	  }
	}
	.news{
		padding:0px 20px 20px 20px;
		.news-title{
			font-size: 20px;
			color: #222222;
			margin-bottom: 15px;
			text-align: center;
		}
		.news-box{
			border-bottom: 1px solid #F8F8F8;
			margin-bottom: 10px;
			padding-bottom: 10px;

			.news-name{
				font-size: 16px;
				line-height: 1.6;				
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.news-time{
				font-size: 12px;
				text-align: right;
				margin: 5px 0;
    			color: #aaa;
			}
		}
		.news-more{
			text-align: center;
			font-size: 14px;
			color: #fd5353;
		}
	}
</style>
